import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33.39 17.231"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Group 5557\" transform=\"translate(-1761.18 -519.919)\"><g data-name=\"Rectangle 3272\" transform=\"translate(1761.18 519.919)\" style=\"stroke:#f59600;fill:none;\"><rect width=\"33.389\" height=\"17.231\" rx=\"2\" style=\"stroke:none;\" stroke=\"none\"></rect><rect x=\".5\" y=\".5\" width=\"32.389\" height=\"16.231\" rx=\"1.5\" style=\"fill:none;\"></rect></g><rect data-name=\"Rectangle 3273\" width=\"16.988\" height=\"17.231\" rx=\"2\" transform=\"translate(1777.582 519.919)\" style=\"fill:#f59600;\"></rect></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };